var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.849 16.25 3.15-1.9 3.15 1.925-.825-3.6 2.775-2.4-3.65-.325-1.45-3.4-1.45 3.375-3.65.325 2.775 2.425-.825 3.575Zm3.15.45-4.15 2.5a.908.908 0 0 1-.575.15.966.966 0 0 1-.525-.2 1.2 1.2 0 0 1-.35-.438.874.874 0 0 1-.05-.587l1.1-4.725-3.675-3.175a.958.958 0 0 1-.275-1.075c.067-.183.167-.333.3-.45.133-.117.317-.192.55-.225l4.85-.425 1.875-4.45a.9.9 0 0 1 .387-.45c.175-.1.355-.15.538-.15.183 0 .362.05.537.15.175.1.305.25.388.45l1.875 4.45 4.85.425c.233.033.417.108.55.225.133.117.233.267.3.45a.958.958 0 0 1-.275 1.075L16.549 13.4l1.1 4.725a.874.874 0 0 1-.05.587 1.2 1.2 0 0 1-.35.438.966.966 0 0 1-.525.2.908.908 0 0 1-.575-.15l-4.15-2.5Z",
    fill: "#104239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b57e203cf59f96677b15072ad70d1752.svg";
export { ForwardRef as ReactComponent };